import { STATUSES } from '../../../constants/statuses';
import { ROLES } from '../../../constants/roles';
import { fetchIndexAndConvertToTreeData } from '../../../utils/folderToTreeData';

// export const treeData = [
//     {
//         nodeId: "1",
//         label: "0000",
//         children: [
//             {
//                 nodeId: "2", label: "1-module-1-administrative-information",
//                 children: [
//                     { nodeId: "3", label: "m1-administrative-information.xml" },
//                     { nodeId: "4", label: "BLA_Cover_Letter.txt" },
//                 ]
//             },
//         ]
//     },
//     {
//         nodeId: "5",
//         label: "0001",
//         children: [
//             {
//                 nodeId: "6", label: "2-module-2-common-technical-document-summaries",
//                 children: [
//                     { nodeId: "7", label: "27-clin-sum",
//                         children: [
//                             { nodeId: "8", label: "Clinical_Summary.txt" },
//                         ]
//                      },
//                     { nodeId: "9", label: "24-nonclin-over",
//                         children: [
//                             { nodeId: "10", label: "Nonclinical_Overview.txt" },
//                         ]
//                      },
//                 ]
//             },
//         ]
//     },
//     {
//         nodeId: "11",
//         label: "0002",
//         children: [
//             {
//                 nodeId: "12", label: "3-module-3-quality",
//                 children: [
//                     { nodeId: "13", label: "CMC_Summary.txt" },
//                 ]
//             },
//         ]
//     },
//     {
//         nodeId: "14",
//         label: "0003",
//         children: [
//             {
//                 nodeId: "15", label: "4-module-4-nonclinical-study-reports",
//                 children: [
//                     { nodeId: "16", label: "Toxicology_Report.txt" },
//                 ]
//             },
//         ]
//     },
//     {
//         nodeId: "17",
//         label: "0004",
//         children: [
//             {
//                 nodeId: "18", label: "5-module-5-clinical-study-reports",
//                 children: [
//                     { nodeId: "19", label: "CSR_Main.txt" },
//                 ]
//             },
//         ]
//     },
//     {
//         nodeId: "20",
//         label: "index.xml",
//     },
// ];

/**
 * Load tree data from index.json
 * @returns {Promise<Array>} Tree data structure
 */
export const loadTreeData = async () => {
  try {
    const treeData = await fetchIndexAndConvertToTreeData();
    // console.log('✅ Tree data loaded successfully');
    return treeData;
  } catch (error) {
    console.error('❌ Failed to load tree data:', error);
    return [];
  }
};

// For backward compatibility - export empty array initially
// Components should use loadTreeData() async function
export const treeData = [];

export const rolesValidated = [
    {
        role: ROLES.technical_validator,
        status: STATUSES.ROLE_STATUSES[ROLES.technical_validator].ACTIVE
    },
    {
        role: ROLES.core_Validator,
        status: STATUSES.ROLE_STATUSES[ROLES.core_Validator].ACTIVE
    },
    {
        role: ROLES.RA,
        status: STATUSES.ROLE_STATUSES[ROLES.RA].ACTIVE
    },
    // {
    //     role: ROLES.committee_ectd,
    //     status: STATUSES.ROLE_STATUSES[ROLES.committee].ACTIVE
    // }
];

// export const roles = ['Technical Validator', 'Assessment Reviewer - eCTD', 'Core Validator', 'Committee'];

// export const statuses = [STATUSES.ROLE_STATUSES[ROLES.technical_validator].ACTIVE,
// STATUSES.ROLE_STATUSES[ROLES.core_Validator].ACTIVE, STATUSES.ROLE_STATUSES[ROLES.RA].ACTIVE, STATUSES.ROLE_STATUSES[ROLES.committee].ACTIVE];